import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const FinancialOperations = lazy(() => import('./FinancialOperations'));

export const financialOperationRoutes: RouteObject[] = [
  { path: 'financial-operations', element: <FinancialOperations /> },
];
